module.exports = __webpack_public_path__ + "img/NAM.5aac3130.svg";